import { createStore } from '@nile/mangifera/src/StoreManager/store/createStore';

export interface Ticket {
  ticketId: string;
  displayId: string;
  subject: string;
  siteName: string;
  resolved: boolean;
}

type SimilarTickets = Ticket[];

const similarTicketsConfig = {
  id: 'similarTicketsStore',
  initialState: {
    similarTicketsData: null,
    selectedHeader: 'all',
    summaryData: null
  },

  methods: (set, get) => ({
    setSimilarTicketsData: (data: SimilarTickets) => {
      set({
        similarTicketsData: data
      });
    },
    setSelectedHeader: (header: string) => {
      set({
        selectedHeader: header
      });
    },
    setSummaryData: (data: any) => {
      set({
        summaryData: data
      });
    },

    resetSimilarTicketsData: () => {
      set({
        similarTicketsData: null,
        selectedHeader: 'all',
        summaryData: null
      });
    }
  }),
  cache: {
    expiryTime: 300,
    strategy: 'memory',
    tabBehavior: 'persist',
    clearOnRefresh: true
  }
};

export const useSimilarTicketsStore = createStore(similarTicketsConfig);
